import {z} from 'zod'

import {CreateOrUpdateBlockAutoplayDocument} from '@sdox/api'

import {createFormConfig} from '../../utils/createFormConfig'
import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'

import type {BlockAutoplayInput, CreateOrUpdateBlockAutoplayMutation} from '@sdox/api'

type CreateAutoplayValidatorSchema = z.infer<typeof createAutoplayValidatorSchema>

const createAutoplayValidatorSchema = z.object({
  data: z.object({
    video: z.object({
      fileHash: z.string().min(1),
    }),
  }),
  meta: createMetaSchema,
})

export const autoplayConfig = createFormConfig<
  CreateAutoplayValidatorSchema,
  CreateOrUpdateBlockAutoplayMutation,
  BlockAutoplayInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockAutoplayDocument,
  },
  fieldMapper: (fieldValues) => ({
    fileHash: fieldValues.data.video.fileHash,
  }),
  validatorSchema: createAutoplayValidatorSchema,
  inputFields: [
    {
      label: 'Video',
      fieldName: 'data.video',
      inputType: 'video',
      defaultValue: '',
      required: true,
    },
  ],
})
